module.exports = __webpack_public_path__ + "media/images/home/focus-favicon-a8e3c07aabaf34270d877643e0f4445a.png";